import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { X, Check } from "lucide-react";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";

import { getChainScanner } from "lib/node";

interface TransferCompletedScreenProps {
  amount: string;
  assetName: string;
  claimTx: string;
  toChain: string;
  onClose: () => void;
  onTransferAgain: () => void;
}

export function TransferCompletedScreen({
  amount,
  assetName,
  claimTx,
  toChain,
  onClose,
  onTransferAgain,
}: TransferCompletedScreenProps) {
  useLingui();
  const history = useHistory();
  const explorerUrl = useMemo(() => {
    return getChainScanner(toChain as any) + "tx/" + claimTx;
  }, [claimTx, toChain]);
  return (
    <div className="mt-[60px] flex  flex-col px-4 py-6 md:px-8 md:py-10">
      <div className="mx-auto flex w-full max-w-screen-md justify-end">
        <button
          onClick={onClose}
          className="py-2.5 hover:bg-muted flex w-fit items-center gap-2 rounded-full bg-[#1E1E1F] px-6 py-6 text-[16px] text-[#ffff6] ring-1 ring-[#fff56] transition-colors hover:ring-[#FFF] md:text-[20px]"
          aria-label={t`Close`}
        >
          <X />
        </button>
      </div>

      <div className="mx-auto -mt-10 flex w-full max-w-screen-md flex-col items-center justify-center gap-20">
        <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-[#00EC97] md:h-[90.5px] md:w-[90.5px]">
          <Check className="h-[40px] w-[40px] text-black md:h-[68px] md:w-[68px]" strokeWidth={3} />
        </div>

        <h1 className="text-foreground mt-6 text-balance text-center text-24 font-bold md:text-34">
          <Trans>Transfer completed</Trans>
        </h1>

        <div className="mt-10 text-center md:mt-14">
          <p className="text-[14px] text-[#ffffff66] md:text-[16px]"><Trans>Total amount</Trans></p>
          <p className="mt-2 font-mono text-[24px] font-bold text-[#00EC97] md:text-24">
            {amount} {assetName}
          </p>
        </div>

        <p className="leading-relaxed md:leading-8 mt-8 text-pretty text-center text-[16px] font-medium text-[#ffff] md:text-[20px]">
          <Trans>Has been successfully sent to your Nectarliquid balance</Trans>
        </p>

        <div className="mt-12 flex w-full flex-col items-center md:mt-16">
          <p
            onClick={() => window.open(explorerUrl, "_blank")}
            className="text-foreground text-sm md:text-base mb-12 cursor-pointer font-medium underline-offset-4 transition-colors hover:text-[#00EC97] hover:underline"
          >
            <Trans>View transaction on explorer</Trans>
          </p>

          <div className="mt-9 flex w-full max-w-screen-sm gap-3 md:gap-8">
            <button
              onClick={onTransferAgain}
              className="flex-1 rounded-full bg-[#00EC97] py-4 text-[16px] font-semibold text-black transition-all hover:brightness-110 active:scale-[0.98] md:py-10 md:text-[18px]"
            >
              <Trans>Transfer again</Trans>
            </button>
            <button
              type="button"
              onClick={() => history.push("/trade")}
              className="flex-1 rounded-full border border-[#00EC97B8] py-4 text-[16px] font-semibold text-[#00EC97B8] transition-all hover:bg-[#00EC97B8]/10 active:scale-[0.98] md:py-5 md:text-[18px]"
            >
              <Trans>Continue trading</Trans>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
